import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateWechatState } from "../../redux/slice/wechatSlice";
import BottomNavLayout from "../../components/BottomNavLayout";
import HomeSwiper from "./HomeSwiper";
import HomeIconList from "./HomeIconList";
import HomeInstruction from "./HomeInstruction";
import { isWxOrAli } from "../../utils/env";
import api from "../../api";

const Home = () => {

  // 常用功能Icon列表
  const icons = [
    {
      name: '充电',
      link: '/scan',
      img: 'https://cdz-public.oss-cn-hangzhou.aliyuncs.com/assets/images/home_charge.png',
    }, {
      name: '订单',
      link: '/order',
      img: 'https://cdz-public.oss-cn-hangzhou.aliyuncs.com/assets/images/home_orders.png',
    }, {
      name: '会员卡',
      link: '/wallet/1',
      img: 'https://cdz-public.oss-cn-hangzhou.aliyuncs.com/assets/images/home_vip.png',
    }, {
      name: 'IC卡',
      link: '/card/list',
      img: 'https://cdz-public.oss-cn-hangzhou.aliyuncs.com/assets/images/home_card.png',
    }
  ]

  const wechatState = useSelector((state) => state.wechat)
  const dispatch = useDispatch()
  const lanuchRef = useRef(null);

  // 处理ios异常url
  let url = wechatState.ios ? wechatState.url : window.location.href;

  // 判断当前是微信 or 支付宝
  const aliOrWx = isWxOrAli();

  // 获取全局wx对象
  const wx = window.wx;

  // 微信初始化配置
  // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#4
  const wxConfig = (realAuthUrl) => {
    api.wechatJsapiSignature({ url: realAuthUrl }).then((res) => {
      let signature = res.data.data;
      signature.jsApiList = ['scanQRCode', 'chooseWXPay'];
      signature.openTagList = ['wx-open-launch-weapp'];

      wx.config(signature);

      wx.ready(function () {
        // IOS环境特殊处理
        if (wechatState.ios) {
          const newWechatState = {
            url: wechatState.url,
            ios: wechatState.ios,
            loaded: wechatState.loaded,
            iosReady: true
          }
          dispatch(updateWechatState(newWechatState))
        }

        // alert("config ok")
      });

      wx.error(function (res) {
        // alert("error : " + JSON.stringify(res))
      });
    });
  }

  useEffect(() => {
    if (aliOrWx === 'wechat') {
      // 非ios平台每次都需要config
      if (!wechatState.ios) {
        wxConfig(url)
      } else if (wechatState.iosReady) {
        return;
      } else {
        wxConfig(url)
      }

      // lanuchRef.current.addEventListener('ready', function (e) {
      //   alert('ready')
      // })
      // lanuchRef.current.addEventListener('launch', function (e) {
      //   alert('launch')
      // })
      // lanuchRef.current.addEventListener('error', function (e) {
      //   alert('error')
      // })
    }
  }, [])

  return (
    <BottomNavLayout>
      <HomeSwiper aliOrWx={'nothing'} />
      <HomeIconList icons={icons} title="常用功能" />
      <HomeInstruction />
    </BottomNavLayout>
  )
}

export default Home;